import { BaseTicketController } from '../../../../common/base/ticketController';

export class CompletedController extends BaseTicketController {
  constructor(controllerService, ticketFlowService, ticketService, fileResponseService) {
    'ngInject';
    super({ controllerService, ticketFlowService, ticketService, fileResponseService });
  }

  $onInit() {
    super.$onInit();
    // Only show download package button for incoming requests
    this.showDownloadPackage = this.ticketFlowService.isReceivingTicket(this.ticket);
  }

  downloadPackage() {
    const { ticketService, fileResponseService, isDownloadBusy } = this;
    const { ticket } = this;

    if (isDownloadBusy) {
      return;
    }

    ticketService
      .accountSwitchPackage(ticket.id, ticket.requestType)
      .busy(this, 'isDownloadBusy')
      .then(file => fileResponseService.saveAs(file));
  }

  navigateToList() {
    const { ticketFlowService } = this;

    const state = ticketFlowService.getRouteForTicket(this.ticket, 'list');
    this.go(state);
  }
}
